import React from 'react';
import RegistrationForm from "./RegistrationForm";
import Header from "./Header";
import Footer from "./Footer";
import useTokenVerification from '../utilities/customHooks/useTokenValidation';
import MLDCReactLoadingIndicator from "@metlife/mldc-react-loading-indicator";

function Registration() {
  const { linkVerified, loading, tokenPresent } = useTokenVerification();

  if (loading) {
    return <div style={{margin:"20rem"}}><MLDCReactLoadingIndicator/></div>;
  } else if (!tokenPresent) {
    // Token is not present, load the registration page normally
    return (
      <div className='registration' style={{backgroundColor:"#ffffff"}}>
        <Header/>
        <RegistrationForm />
        <Footer/>
      </div>
    );
  } else if (!linkVerified) {
    // Token is present but not verified, navigation is handled in the hook
    return null;
  } else {
    // Token is present and verified
    return (
      <div className='registration' style={{backgroundColor:"#ffffff"}}>
        <Header/>
        <RegistrationForm />
        <Footer/>
      </div>
    );
  }
}

export default Registration;